
import { useState, FormEvent } from 'react';

const whatsappLink = "https://wa.me/5511922305730?text=Olá%2C%20Daniel!%20Tenho%20um%20imóvel%20em%20Brasília%20e%20gostaria%20de%20uma%20avaliação%20gratuita.";

const FormularioProprietario = () => {
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [charCount, setCharCount] = useState(0);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const textarea = form.querySelector('textarea[name="mensagem"]') as HTMLTextAreaElement;
    if (textarea && textarea.value.length > 500) return;

    setLoading(true);
    const data = new FormData(form);
    const params = new URLSearchParams();
    data.forEach((value, key) => params.append(key, value as string));

    try {
      await fetch('https://readdy.ai/api/form/d6hdqu5pk1ctp7d9b2b0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: params.toString(),
      });
      setSubmitted(true);
    } catch {
      setSubmitted(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="formulario" className="py-24 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-16 items-start">
            {/* Info lateral */}
            <div>
              <span className="inline-block px-4 py-2 bg-teal-100 rounded-full text-teal-700 font-semibold text-sm tracking-wider uppercase mb-6">
                Cadastre Seu Imóvel
              </span>
              <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
                Fale Conosco e Receba uma{' '}
                <span className="bg-gradient-to-r from-teal-600 to-emerald-600 bg-clip-text text-transparent">
                  Avaliação Gratuita
                </span>
              </h2>
              <p className="text-lg text-gray-600 mb-10 leading-relaxed">
                Preencha o formulário e nossa equipe entrará em contato em até 24 horas com uma análise completa do seu imóvel em Brasília.
              </p>

              <div className="space-y-6">
                {[
                  { icon: 'ri-map-pin-2-fill', color: 'bg-teal-100 text-teal-600', title: 'Especialistas em Brasília, DF', desc: 'Conhecemos cada bairro e o valor real de cada imóvel na capital.' },
                  { icon: 'ri-money-dollar-circle-fill', color: 'bg-emerald-100 text-emerald-600', title: 'Avaliação 100% Gratuita', desc: 'Sem taxas, sem compromisso. Saiba o valor do seu imóvel agora.' },
                  { icon: 'ri-customer-service-2-fill', color: 'bg-orange-100 text-orange-600', title: 'Atendimento Personalizado', desc: 'Cada proprietário recebe atenção exclusiva e estratégia sob medida.' },
                ].map((item, i) => (
                  <div key={i} className="flex items-start gap-4">
                    <div className={`w-12 h-12 ${item.color} rounded-xl flex items-center justify-center flex-shrink-0`}>
                      <i className={`${item.icon} text-xl`}></i>
                    </div>
                    <div>
                      <h4 className="font-bold text-gray-900 mb-1">{item.title}</h4>
                      <p className="text-gray-600 text-sm">{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>

              <div className="mt-10 p-6 bg-gray-50 rounded-2xl border border-gray-100">
                <p className="text-gray-600 text-sm mb-4">Prefere falar diretamente?</p>
                <a
                  href={whatsappLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-3 bg-green-500 hover:bg-green-600 text-white px-6 py-3 rounded-lg font-bold transition-all hover:shadow-lg whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-whatsapp-fill text-xl"></i>
                  Chamar no WhatsApp
                </a>
              </div>
            </div>

            {/* Formulário */}
            <div className="bg-white rounded-3xl shadow-2xl border border-gray-100 p-8 lg:p-10">
              {submitted ? (
                <div className="text-center py-12">
                  <div className="w-20 h-20 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-6">
                    <i className="ri-check-double-line text-4xl text-teal-600"></i>
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>
                    Mensagem Enviada!
                  </h3>
                  <p className="text-gray-600 mb-8">
                    Recebemos seus dados. Nossa equipe entrará em contato em até 24 horas com a avaliação do seu imóvel.
                  </p>
                  <a
                    href={whatsappLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white px-6 py-3 rounded-lg font-bold transition-all whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-whatsapp-fill text-xl"></i>
                    Falar Agora no WhatsApp
                  </a>
                </div>
              ) : (
                <form
                  data-readdy-form
                  id="form-proprietarios-brasilia"
                  onSubmit={handleSubmit}
                  className="space-y-5"
                >
                  <div>
                    <h3 className="text-2xl font-bold text-gray-900 mb-2" style={{ fontFamily: "'Playfair Display', serif" }}>
                      Cadastre Seu Imóvel
                    </h3>
                    <p className="text-gray-500 text-sm mb-6">Preencha os dados abaixo e receba sua avaliação gratuita</p>
                  </div>

                  <div className="grid sm:grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-1.5">Nome Completo *</label>
                      <input
                        type="text"
                        name="nome"
                        required
                        placeholder="Seu nome"
                        className="w-full border border-gray-200 rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-teal-400 focus:border-transparent transition-all"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-1.5">WhatsApp *</label>
                      <input
                        type="tel"
                        name="whatsapp"
                        required
                        placeholder="(61) 9 0000-0000"
                        className="w-full border border-gray-200 rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-teal-400 focus:border-transparent transition-all"
                      />
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-1.5">E-mail</label>
                    <input
                      type="email"
                      name="email"
                      placeholder="seu@email.com"
                      className="w-full border border-gray-200 rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-teal-400 focus:border-transparent transition-all"
                    />
                  </div>

                  <div className="grid sm:grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-1.5">Tipo do Imóvel *</label>
                      <select
                        name="tipo_imovel"
                        required
                        className="w-full border border-gray-200 rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-teal-400 focus:border-transparent transition-all bg-white cursor-pointer"
                      >
                        <option value="">Selecione</option>
                        <option value="Apartamento">Apartamento</option>
                        <option value="Casa">Casa</option>
                        <option value="Cobertura">Cobertura</option>
                        <option value="Terreno">Terreno</option>
                        <option value="Comercial">Comercial</option>
                        <option value="Outro">Outro</option>
                      </select>
                    </div>
                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-1.5">Objetivo *</label>
                      <select
                        name="objetivo"
                        required
                        className="w-full border border-gray-200 rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-teal-400 focus:border-transparent transition-all bg-white cursor-pointer"
                      >
                        <option value="">Selecione</option>
                        <option value="Vender">Quero Vender</option>
                        <option value="Alugar">Quero Alugar</option>
                        <option value="Vender ou Alugar">Vender ou Alugar</option>
                      </select>
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-1.5">Bairro / Região em Brasília *</label>
                    <input
                      type="text"
                      name="bairro"
                      required
                      placeholder="Ex: Asa Sul, Lago Norte, Águas Claras..."
                      className="w-full border border-gray-200 rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-teal-400 focus:border-transparent transition-all"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-1.5">
                      Mensagem adicional
                      <span className="text-gray-400 font-normal ml-1">({charCount}/500)</span>
                    </label>
                    <textarea
                      name="mensagem"
                      rows={3}
                      maxLength={500}
                      placeholder="Conte mais sobre seu imóvel (metragem, quartos, valor esperado...)"
                      onChange={(e) => setCharCount(e.target.value.length)}
                      className="w-full border border-gray-200 rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-teal-400 focus:border-transparent transition-all resize-none"
                    />
                  </div>

                  <button
                    type="submit"
                    disabled={loading}
                    className="w-full bg-gradient-to-r from-teal-600 to-emerald-600 hover:from-teal-700 hover:to-emerald-700 text-white py-4 rounded-lg font-bold text-lg transition-all hover:shadow-xl disabled:opacity-60 whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
                  >
                    {loading ? (
                      <><i className="ri-loader-4-line animate-spin text-xl"></i> Enviando...</>
                    ) : (
                      <><i className="ri-send-plane-fill text-xl"></i> Solicitar Avaliação Gratuita</>
                    )}
                  </button>

                  <p className="text-center text-xs text-gray-400">
                    <i className="ri-lock-line mr-1"></i>
                    Seus dados estão seguros. Não compartilhamos com terceiros.
                  </p>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FormularioProprietario;
